import App from './App.svelte';

const app = new App({
	target: document.body,
	props: {
		name: 'Knolval PWA',
		version: "0.39"
	}
});

export default app;